import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAgSachbearbeiterListResponseDto, IManagerProfileAuftragResponseDto } from "../types/Types";

/**
 * @author mb
 */
export const AgSachbearbeiterAPI = createApi({
    reducerPath: "AgSachbearbeiterAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "agsachbearbeiter",
            credentials: 'include'
        }),
    tagTypes: ['AgSachbearbeiterAPI'], // for caching
    endpoints: (builder) => ({
        getAuftraege: builder.mutation<IAgSachbearbeiterListResponseDto[], void>(
            {
                query: () => ({
                    url: '/auftraege',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

    })
});

export const {

    useGetAuftraegeMutation,

} = AgSachbearbeiterAPI;
